module.exports = __webpack_public_path__ + "static/media/store-wbd-icon.a1c8552d.svg";